import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { SKUDetails } = await import('@containers/Payment/SKUDetails');
    return {
        Component: SKUDetails,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
